/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Open_MenuInputs */



/**
* | output |
* | --- |
* | "Open menu" |
*
* @param {Nav_Open_MenuInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nav_open_menu = /** @type {((inputs?: Nav_Open_MenuInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Open_MenuInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Open menu")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir le menu")
	return /** @type {LocalizedString} */ ("Open menu")
});